// Status renkleri — kod bazlı; gerçek renk değerleri temaya göre CSS değişkenlerinden gelir
// (styles/admin-corporate.css içindeki --st-* tanımları), böylece açık/koyu modda okunabilirlik korunur.
// Gönderim listesi, filtre çipleri ve kanban görünümleri arasında paylaşılır.
const KNOWN_CODES = ['forwarded', 'inproduction', 'shipped', 'completed'];

function paletteFor(key) {
  return {
    bg: `var(--st-${key}-bg)`,
    border: `var(--st-${key}-border)`,
    text: `var(--st-${key}-text)`,
  };
}

const FALLBACK_COLOR = paletteFor('default');

export function statusColor(code) {
  if (!code) return FALLBACK_COLOR;
  const key = code.toLowerCase();
  return KNOWN_CODES.includes(key) ? paletteFor(key) : FALLBACK_COLOR;
}

// Backend'deki Status.Code'u normalize eder — "Completed" gibi değerleri büyük harfle karşılaştırmak için
export function isCompletedCode(code) {
  return (code || '').toUpperCase() === 'COMPLETED';
}
